import { useListenDocumentEvent } from './common/use-listen-document-event.hook';

export function useListenDocumentMousedownEvent<T extends HTMLDivElement>(cb: (ev: MouseEvent) => void) {
  useListenDocumentEvent('mousedown', cb);
}